import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import * as Api from "@/api";
import Search from "@/design/components/Search";
import useSearch from "@/utils/hooks/useSearch";
import Valkyrie, { viPerson, viXmark } from "@sippy-platform/valkyrie";

import { Alert, Box, Button, Drawer, IconButton, List, ListItem, ListItemText, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";

import MemberItem from "./MemberItem";

function GroupMembers({ dispatch, group }) {
  const allUserStore = useSelector((state) => state.domain.allUsers);

  // Fetch data from API
  useEffect(() => {
    Promise.resolve(Api.getAllUsers());
  }, []);

  // Drawer
  const [drawer, setDrawer] = useState(null);
  const [searchValue, setSearchValue] = useState("");

  const searchResults = useSearch(allUserStore.list, searchValue, ["name", "exten"]);

  const closeDrawer = useCallback(() => {
    setDrawer(undefined);
    setSearchValue("");
  }, []);

  return (
    <>
      <Button onClick={() => setDrawer(true)} variant="contained" startIcon={<Valkyrie icon={viPerson} />}>
        Manage
      </Button>
      <Drawer
        open={!!drawer}
        onClose={() => closeDrawer()}
        anchor="right"
        slotProps={{
          paper: {
            sx: (theme) => ({ maxWidth: 320, width: 1, p: 1.5, display: "flex", gap: 1, ...theme.scrollbar }),
            elevation: 4,
          },
        }}
      >
        <Stack
          direction="row"
          sx={{
            gap: 1,
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h5">Manage members</Typography>
          <IconButton onClick={() => closeDrawer()} color="inherit">
            <Valkyrie icon={viXmark} />
          </IconButton>
        </Stack>
        <Box sx={{ position: "sticky", top: 0, zIndex: 1000 }}>
          <Search blur value={searchValue} onChange={setSearchValue} />
        </Box>
        {group.members.length >= 50 && (
          <Alert severity="info" sx={{ mb: 1 }}>
            You have reached the limit of 50 members in this group.
          </Alert>
        )}
        <List>
          {searchResults.length >= 1 ? (
            searchResults.map((user) => <MemberItem key={user.id} user={user} dispatch={dispatch} group={group} />)
          ) : (
            <ListItem>
              <ListItemText primary="There are no users available..." />
            </ListItem>
          )}
        </List>
      </Drawer>
    </>
  );
}

GroupMembers.propTypes = {
  group: PropTypes.object,
  dispatch: PropTypes.func,
};

export default GroupMembers;
